/* 🤖 this file was generated by svg-to-ts */
export const matIconSubject: {
  name: 'subject';
  data: string;
} = {
  name: 'subject',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"/></svg>`
};
